<template>
  <div class="user_archive_edit">
    <span>{{ $t('meta_title.user.archive.edit') }}</span>

    <div class="user_form">
      <form @submit.prevent="patch" method="post">
        <div class="form-group">
          <label for="user_firstname" class="required">{{ $t('object.user.firstname') }}</label>
          <input type="text" id="user_firstname" name="firstname" class="form-control"
                 v-model="firstname">
        </div>
        <div class="form-group">
          <label for="user_lastname" class="required">{{ $t('object.user.lastname') }}</label>
          <input type="text" id="user_lastname" name="lastname" class="form-control"
                 v-model="lastname">
        </div>

        <div class="form-group">
          <label for="user_email" class="required">{{ $t('object.user.email') }}</label>
          <input type="email" id="user_email" name="email" class="form-control"
                 v-model="email">
        </div>

        <div class="form-group">
          <label for="user_restore" class="required">{{ $t('action.archive.restore') }}</label>
          <input type="checkbox" id="user_restore" value="true" name="restore" class="form-control"
                 v-model="restore">
        </div>

        <input type="submit">
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UserEditArchive',
    data() {
      return {
        firstname: '',
        lastname: '',
        email: '',
        restore: '',
      }
    },
    created() {
      this.$http.get('user/archive/' + this.$route.params.id)
        .then(response => {
          this.firstname = response.data.firstname
          this.lastname  = response.data.lastname
          this.email     = response.data.email
        })
    },
    methods: {
      patch() {
        this.$http.patch('user/archive/' + this.$route.params.id, {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          restore: this.restore,
        }, {
          redirectOnSuccess: {name: 'UserListArchive', params: {id: this.$route.params.id}}
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/edit_archive.vue